import React, { useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { BlockType } from '../../containers/LessonPage/types'
import { useDispatch, useSelector } from 'react-redux'
import * as blockActions from '../../containers/AdminBlockEditPage/actions'
import { InitialState } from '../../containers/AdminBlockEditPage/types'

// Styles
import './styles.scss'

export default ({ block }: { block: BlockType }) => {
  const dispatch = useDispatch()

  const {
    lastUploadedFiles,
    processIsUploadFiles,
    processIsAssignFilesToBlock,
  } = useSelector(
    (state: { adminBlockEdit: InitialState }) => state.adminBlockEdit
  )

  useEffect(() => {
    if (lastUploadedFiles.length && block.files) {
      dispatch(
        blockActions.assignFilesToBlock(
          block.block_id,
          block.files.block_file_id,
          [
            ...block.files.files.map(file => file.media_file_id),
            ...lastUploadedFiles,
          ]
        )
      )
      dispatch(blockActions.uploadedFilesDestroy())
    }
  }, [lastUploadedFiles])

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles.length) {
      dispatch(blockActions.uploadFiles(acceptedFiles))
    } else {
      alert('Необходимо выбрать файл!')
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled: processIsUploadFiles || processIsAssignFilesToBlock,
  })

  const handleRemoveFile = (file_id: string) => {
    if (block.files) {
      const filesIds = block.files.files
        .filter(file => file.media_file_id !== file_id)
        .map(file => file.media_file_id)
      dispatch(
        blockActions.assignFilesToBlock(
          block.block_id,
          block.files.block_file_id,
          filesIds
        )
      )
    }
  }

  return (
    <div className={'admin-files-block'}>
      <h2>Файлы:</h2>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <td>
              <b>Название файла</b>
            </td>
            <td width={100} />
          </tr>
        </thead>
        <tbody>
          {block.files?.files && block.files.files.length ? (
            block.files.files.map(file => (
              <tr key={file.media_file_id}>
                <td style={{ display: 'flex', flexDirection: 'row' }}>
                  {file.file.name}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <button onClick={() => handleRemoveFile(file.media_file_id)}>
                    Удалить
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td style={{ textAlign: 'center' }} colSpan={2}>
                <b>Нет добавленных файлов!</b>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className={'admin-files-block__upload'} {...getRootProps()}>
        <input
          {...getInputProps()}
          disabled={processIsUploadFiles || processIsAssignFilesToBlock}
        />
        {processIsUploadFiles ? (
          <div className={'loading-outer'}>
            <div className="loading">
              <div className="loading__wrapper">
                {new Array(17).fill(<div />).map(block => block)}
              </div>
            </div>
            <span className={'loading-text'}>Отправка файлов...</span>
          </div>
        ) : isDragActive ? (
          <p style={{ color: '#000' }}>Отпустите файлы...</p>
        ) : (
          <p>Переместите файлы сюда или нажмите для выбора...</p>
        )}
      </div>
    </div>
  )
}
